import React from 'react';
import Typography from 'components/commercetools-ui/atoms/typography';
import { LinkReference, Reference } from 'types/reference';
import { FooterLink } from '../types';

export interface Props {
  header?: string;
  links: FooterLink[];
  className?: string;
}

const Column: React.FC<Props> = ({ header, links, className }) => {
  return (
    <div className={className}>
      {header && (
        <Typography as="h3" className="self-start pb-20 text-18 font-bold uppercase text-input-focusBorder sm:pb-10">
          {header}
        </Typography>
      )}
      <ul role="list" className="mb-3 flex flex-col items-start self-start">
        {links.map((item, i) => (
          <li className="leading-6" key={i}>
            <a
              className="duration-400 text-14 font-semibold text-secondary-grey hover:text-ag_color-text_green"
              href={item?.url}
            >
              <Typography as="fragment">{item?.text}</Typography>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Column;
